module.exports = __webpack_public_path__ + "img/Green.0f1244c6.svg";